<template>
  <div>
    <SfNotification
        :icon="{icon: icons.info.path, viewBox: icons.info.viewBox}"
        :message="notification.message"
        :type="notification.type"
        :visible="notification.isVisible"
        class="notification"
        @click:close="notification.isVisible = false"
    >
      <template #icon>
        <SfIcon :icon="icons.info.path" :view-box="icons.info.viewBox" class="icon" color="white"/>
      </template>
    </SfNotification>
    <form autocomplete="off" class="form" @submit.prevent="submitForm">
      <SfInput
          v-model="password"
          :error-message="password ? $t('accountForm.password.error') : $t('accountForm.password.required')"
          :has-show-password="true"
          :label="$t('myProfile.passwordUpdate.form.password')"
          class="form__element"
          name="password"
          required
          type="password"
          @blur="passwordBlur = false"
      />
      <span class="passwordNotice">{{ $t('myProfile.passwordUpdate.tab.message') }}</span>
      <SfInput
          v-model="newPassword"
          :error-message="newPassword? $t('accountForm.newPassword.error') : $t('accountForm.newPassword.required')"
          :has-show-password="true"
          :label="$t('myProfile.passwordUpdate.form.newPassword')"
          class="form__element password-input"
          name="newPassword"
          required
          type="password"
          @blur="newPasswordBlur = false"
      />
      <OrkPasswordJudge :password="newPassword" @password-validity="onPasswordValid"/>
      <SfInput
          v-model="repeatPassword"
          :error-message="repeatPassword? $t('accountForm.repeatPassword.error') : $t('accountForm.repeatPassword.required')"
          :has-show-password="true"
          :label="$t('myProfile.passwordUpdate.form.repeatPassword')"
          :valid="repeatPasswordBlur || validRepeatPassword(repeatPassword)"
          class="form__element repeat-password-input"
          name="repeatPassword"
          required
          type="password"
          @blur="repeatPasswordBlur = false"
      />
      <div v-if="error">
        <SfAlert :message="$t(error)" :visible="true"/>
      </div>
      <div class="form-action">
        <SfButton
            :disabled="loading"
            class="sf-button color-secondary"
            type="submit"
        >
          <div v-if="loading">
            <SfLoader :class="{ loader: loading }"
                      :loading="loading"></SfLoader>
            {{ $t('Loading') }}
          </div>
          <div v-else> {{ $t('myProfile.passwordUpdate.form.button') }}</div>
        </SfButton>
      </div>
    </form>
  </div>
</template>

<script>

import {SfAlert, SfButton, SfInput, SfLoader, SfNotification, SfIcon} from '@storefront-ui/vue';
import Api from '@/api/Api';
import icons from "@/utils/icons";
import OrkPasswordJudge from "@/components/Ork/OrkPasswordJudge.vue";

export default {
  name: 'passwordChangeForm',
  components: {
    OrkPasswordJudge,
    SfAlert,
    SfInput,
    SfButton,
    SfLoader,
    SfNotification,
    SfIcon
  },
  data() {
    return {
      loading: false,
      error: null,
      valid: false,
      submitted: false,
      password: null,
      passwordBlur: false,
      repeatPassword: null,
      repeatPasswordBlur: false,
      newPassword: null,
      newPasswordBlur: false,
      notification: {isVisible: false, message: "", type: "success"},
      icons: icons,
      validPassword: false
    }
  },
  methods: {
    validate() {
      this.passwordBlur = false;
      this.newPasswordBlur = false;

      return this.validRepeatPassword(this.repeatPassword) && this.validPassword;
    },
    validRepeatPassword(repeatPassword) {
      if (repeatPassword) {
        return this.newPassword === repeatPassword;
      }
      return true
    },

    submitForm() {
      const onComplete = () => {
        this.loading = false;
        this.error = null;
      }

      const onError = (e) => {
        this.error = `changePassword.error.${e.errorMessage}`;
        this.loading = false;
      };

      if (this.validate()) {
        this.loading = true;
        Api.account.updatePassword({oldPassword: this.password, newPassword: this.newPassword}).then(
            () => {
              onComplete();
              this.notification = {
                isVisible: true,
                message: this.$i18n.t('myProfile.passwordUpdate.notifications.success'),
                type: 'success'
              }
            },
            err => {
              onError(err);
            }
        )
      } else {
        this.error = `changePassword.error.Please check the errors above`
      }
    },
    onPasswordValid(isPasswordValid) {
      this.validPassword = isPasswordValid;
    },
  }
}
</script>

<style lang='scss' scoped>
.notification {
  margin-bottom: 2rem;
}

.form-action {
  margin: var(--spacer-base) auto;
  display: flex;

  ::v-deep {
    .sf-button {
      margin: auto;
      flex: 0;
      white-space: nowrap;
      min-height: 52px;
    }
  }
}

.sf-input.password-input {
  margin-bottom: var(--spacer-xs);

  .sf-input__error-message {
    display: none;
  }
}

.sf-input.repeat-password-input {
  margin-top: var(--spacer-base);
}

::v-deep {
  .sf-icon {
    margin-right: 1rem;
  }
}
</style>